<template>
  <form class="w-100" @submit.prevent="validateBeforeSubmit">
    <md-field>
      <label for="nome">Nome</label>
      <md-input v-model="nome" name="nome" id="nome" v-validate="validate.nome"/>
      <span class="md-helper-text text-warning" v-if="errors.has('nome')">{{ errors.first('nome') }}</span>
    </md-field>
    <md-field>
      <label for="telefone">Telefone</label>
      <md-input v-model="telefone" v-mask="'(##) ##### ####'" name="telefone" id="telefone" v-validate="validate.telefone"/>
      <span class="md-helper-text text-warning" v-if="errors.has('telefone')">{{ errors.first('telefone') }}</span>
    </md-field>
    <div class="d-flex">
      <img :src="imgCaptcha"  class="border rounded" alt="Captcha">
      <md-field class="ml-3">
        <label>Captcha</label>
        <md-input v-model="captcha" placeholder="Digite o Texto ao Lado" maxlength="4" name="captcha" id="captcha" v-validate="validate.captcha"></md-input>
        <span class="md-helper-text text-warning" v-if="errors.has('captcha')">{{ errors.first('captcha') }}</span>
      </md-field>
    </div>
    <md-button :disabled="load" type="submit" class="m-0 mt-4 md-raised md-primary">Ligue-Me</md-button>
    <md-progress-spinner
      v-if="load" :md-diameter="30"
      :md-stroke="4" class="ml-3 mt-4" md-mode="indeterminate"></md-progress-spinner>
    <md-snackbar md-position="left" :md-duration="snackbar.time"
                 :md-active.sync="snackbar.show" md-persistent>
      <span>{{ snackbar.text }}</span>
    </md-snackbar>
  </form>
</template>

<script>
  import {LIGAR_ME_CAPTCHA, LIGAR_ME} from "../consts/api";
  import axios from 'axios';

  export default {
    name: "FormCallToYou",
    data() {
      return {
        nome: '',
        telefone: '',
        captcha: '',
        load: false,
        snackbar: {
          text: '',
          show: false,
          time: 3000
        },
        validate: {
          nome: {
            required: true,
            alpha_spaces: true,
            max: 50,
            min: 2
          },
          telefone: {
            required: true,
            regex: /^\([0-9]{2}\)[ ][0-9]{5}[ ][0-9]{4}$/
          },
          captcha: {
            required: true,
            max: 4,
            min: 4
          },
        },
        imgCaptcha: LIGAR_ME_CAPTCHA
      }
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then(async result => {

          if (result) {
            this.load = true;

            const telefone = this.telefone.replace(/[^\d]/g, '');

            try {
              await axios.post(LIGAR_ME, {
                nome: this.nome,
                telefone: telefone,
                captcha: this.captcha,
              }, { withCredentials: true });

              this.nome = null;
              this.telefone = null;
              this.captcha = null;

              this.snackbar.text = "Em alguns instantes você receberá uma ligação";
              this.snackbar.show = true;

              this.load = false;

            }catch (e) {

              const status = e.response.status;
              this.snackbar.text = "Erro no envio, tente novamente mais tarde!";

              if(status === 401){
                this.snackbar.text = "Captcha Incorreto";
              }

              if(status === 400){
                this.snackbar.text = "Erro no Formulário";
              }

              this.snackbar.show = true;
              this.load = false;
            }
            return;
          }

          this.snackbar.text = "Erro no formulário";
          this.snackbar.show = true;
          this.load = false;
        });
      },
    }
  }
</script>

<style scoped>

</style>
